const es = {
	nav: {
		home: 'INICIO',
		california: 'CALIFORNIA',
		texas: 'TEXAS',
		florida: 'FLORIDA',
		menu: 'MENÚ',
		faq: 'PREGUNTAS',
		freeEstimate: 'Cotización Gratis',
		bookNow: 'RESERVAR',
		myBooking: 'Mi Reserva',
	},
	seo: {
		homeDescription: 'Experiencia Hibachi en Casa mejor calificada. Llevamos nuestra parrilla Hibachi + Chef a su patio en California, Texas y Florida.',
	},
	hero: {
		title: 'FAMILY FRIENDS HIBACHI',
		tagline: 'Hibachi #1 en Casa',
		subtitle: 'Experimente la auténtica cocina hibachi japonesa en su hogar',
		description:
			'Chefs profesionales llevan la emoción de la cocina estilo hibachi directamente a su patio trasero, creando una experiencia gastronómica inolvidable para su familia e invitados.',
		bookNow: 'Reservar Ahora',
		freeEstimate: 'Cotización Gratis',
	},
	howItWorks: {
		title: 'Cómo Funciona',
		subtitle: 'Pasos simples para su fiesta hibachi perfecta',
		step1: {
			title: 'Reserve en Línea',
			description: 'Elija su fecha, hora y preferencias de menú',
		},
		step2: {
			title: 'Nosotros Preparamos',
			description: 'Nuestro equipo se encarga de todos los ingredientes y equipos',
		},
		step3: {
			title: 'Disfrute el Show',
			description: 'Vea a nuestro chef actuar y disfrute de comida deliciosa',
		},
		step4: {
			title: 'Nosotros Limpiamos',
			description: 'Relájese mientras nos encargamos de toda la limpieza',
		},
	},
	menu: {
		title: 'Precios y Servicio',
		subtitle: 'Ingredientes frescos, sabores auténticos',
		proteins: 'Proteínas',
		sides: 'Acompañamientos y Aperitivos',
		chicken: 'Pollo',
		steak: 'Filete Mignon',
		shrimp: 'Camarones',
		salmon: 'Salmón',
		lobster: 'Cola de Langosta',
		tofu: 'Tofu (Vegetariano)',
		friedRice: 'Arroz Frito Hibachi',
		noodles: 'Fideos Yakisoba',
		vegetables: 'Vegetales a la Parrilla',
		salad: 'Ensalada de Jengibre',
		soup: 'Sopa Miso',
		edamame: 'Edamame',
		includes: {
			salad: 'Ensalada Fresca',
			rice: 'Arroz Frito',
			vegetables: 'Vegetales Hibachi',
			show: 'Juego y Show',
		},
		protein: {
			title: 'Opciones de Proteína',
			included: 'Incluido',
		},
		upgrades: {
			title: 'Mejoras Premium',
			filet: 'Filete Mignon',
			lobster: 'Langosta',
			ribeye: 'Ribeye Premium',
			shrimp: 'Camarones Jumbo',
			salmon: 'Salmón Salvaje',
			scallops: 'Vieiras Grandes',
		},
		addons: {
			title: 'Extras',
			gyoza: 'Gyoza (12 pzas)',
			edamame: 'Edamame',
			noodles: 'Fideos',
			thirdProtein: '3ra Proteína',
		},
		coupon: {
			title: 'Cupones Especiales',
			subtitle: '¡Solo fiestas de domingo a viernes!',
			email: 'Envíenos un email a',
		},
		note: {
			outdoor: 'Solo cocinamos al aire libre.',
			weather: 'Brindamos servicio lluvia o sol, siempre que haya un área seca para que el chef cocine.',
		},
	},
	pricing: {
		title: 'Precios',
		subtitle: 'Precios transparentes sin cargos ocultos',
		perPerson: 'persona',
		minimum: 'mínimo para todas las fiestas',
		kids: 'por niño de 12 años y menores',
		includes: 'Incluye',
		includesList: {
			chef: 'Chef hibachi profesional',
			ingredients: 'Todos los ingredientes y suministros',
			equipment: 'Parrilla hibachi y equipo',
			setup: 'Instalación y limpieza',
			show: 'Entretenimiento de cocina en vivo',
		},
		basic: {
			title: 'Paquete Básico',
			description: 'Perfecto para reuniones íntimas',
		},
		premium: {
			title: 'Paquete Premium',
			description: 'Experiencia hibachi completa',
		},
		deluxe: {
			title: 'Paquete Deluxe',
			description: 'Cena de lujo definitiva',
		},
	},
	calendar: {
		available: 'Disponible',
		limited: 'Limitado',
		busy: 'Ocupado',
		unavailable: 'No disponible',
		today: 'Hoy',
		prevMonth: 'Mes anterior',
		nextMonth: 'Mes siguiente',
		weekdays: {
			sun: 'Dom',
			mon: 'Lun',
			tue: 'Mar',
			wed: 'Mié',
			thu: 'Jue',
			fri: 'Vie',
			sat: 'Sáb',
		},
		months: {
			january: 'Enero',
			february: 'Febrero',
			march: 'Marzo',
			april: 'Abril',
			may: 'Mayo',
			june: 'Junio',
			july: 'Julio',
			august: 'Agosto',
			september: 'Septiembre',
			october: 'Octubre',
			november: 'Noviembre',
			december: 'Diciembre',
		},
	},
	slider: {
		chef: 'Chef de Hibachi Profesional en Acción',
		steak: 'Delicioso Bistec Hibachi',
		shrimp: 'Camarones Hibachi Increíbles',
		setup: 'Configuración Hibachi Premium',
		presentation: 'Hermosa Presentación de Comida',
	},
	booking: {
		title: 'Reserve Su Experiencia',
		subtitle: 'Seleccione su región para comenzar',
		selectRegion: 'Seleccione Su Región',
		california: 'California',
		texas: 'Texas',
		florida: 'Florida',
		californiaTagline: 'Hibachi profesional a su puerta',
		texasTagline: 'Llevando excelencia hibachi a Texas',
		floridaTagline: 'Experiencia hibachi en el estado del sol',
		servingAreas: 'Áreas de Servicio',
		bookIn: 'Reservar Ahora',
		note: '* No se requiere pago. Le contactaremos para confirmar.',
		quickBook: 'Reserva Rápida:',
		summary: 'Detalles de Reserva',
		addToCalendar: 'Agregar al Calendario',
	},
	calculator: {
		title: 'Calculadora de Precios',
		subtitle: 'Obtenga un estimado instantáneo para su evento',
		guests: 'Número de Invitados',
		adults: 'Adultos',
		kids: 'Niños (10 y menores)',
		upgrades: 'Mejoras Opcionales',
		summary: 'Resumen de Precios',
		subtotal: 'Subtotal',
		discount: 'Descuento de Grupo',
		minimum: 'Pedido Mínimo',
		total: 'Total',
		gratuity: 'Propina Sugerida',
		grandTotal: 'Total General',
		bookNow: 'Reservar Su Evento',
		note: '* Pueden aplicar tarifas de viaje según la ubicación. Precio final confirmado al reservar.',
		minimumNotice: 'Mínimo 10 invitados requeridos',
		thirdProtein: '3ra Proteína',
		noodles: 'Fideos',
	},
	gallery: {
		title: 'Galería',
		subtitle: 'Experimente la diferencia Family Friends Hibachi',
		items: {
			chef: 'Chef Hibachi Profesional',
			chefDesc: 'Chef Hibachi Profesional en Acción',
			grill: 'Configuración de Parrilla Hibachi',
			grillDesc: 'Configuración Premium de Parrilla Hibachi',
			steak: 'Bistec Hibachi',
			steakDesc: 'Delicioso Bistec Hibachi',
			vegetables: 'Vegetales Hibachi',
			vegetablesDesc: 'Vegetales Hibachi Frescos',
			shrimp: 'Camarones Hibachi',
			shrimpDesc: 'Increíbles Camarones Hibachi',
			food: 'Presentación de Comida',
			foodDesc: 'Hermosa Presentación de Comida',
		},
	},
	reviews: {
		title: 'Lo Que Dicen Nuestros Clientes',
		subtitle: 'Vea lo que dicen nuestros clientes sobre su experiencia Family Friends Hibachi',
		bookNow: 'Reservar Su Evento',
		ctaTitle: '¿Listo para Crear Su Propia Experiencia Increíble?',
		ctaText: 'Únase a cientos de clientes satisfechos',
		rating: '5.0 Calificación Promedio',
		verified: '100+ Reseñas Verificadas',
		topRated: 'Servicio Mejor Valorado',
	},
	instagram: {
		title: 'Siga Nuestro Viaje',
		followUs: 'SÍGUENOS EN INSTAGRAM',
	},
	referral: {
		title: 'Refiera Amigos, Gane Recompensas',
		subtitle: '¡Comparta el amor por el hibachi y obtenga recompensas!',
		step1Title: 'Comparta Su Código',
		step1Desc: 'Comparta su código único de referencia con amigos y familiares',
		step2Title: 'Amigo Reserva',
		step2Desc: 'Su amigo obtiene $30 de descuento en su primera reserva',
		step3Title: 'Usted Gana',
		step3Desc: 'Gane $50 de crédito para su próximo evento',
		yourReward: 'Su Recompensa',
		friendDiscount: 'Descuento del Amigo',
		getCode: 'Obtenga Su Código de Referencia',
		emailPlaceholder: 'Ingrese su correo',
		invalidEmail: 'Por favor ingrese un correo válido',
		getCodeBtn: 'Obtener Código',
		successTitle: '¡Su Código de Referencia Está Listo!',
		successDesc: 'Revise su correo para obtener su código único e instrucciones.',
		terms: '* Las recompensas aplican después de que su amigo complete su primera reserva. ¡Sin límite de referidos!',
	},
	newsletter: {
		title: 'Obtenga Ofertas Exclusivas',
		subtitle: '¡Suscríbase a nuestro boletín para ofertas especiales y consejos de fiesta!',
		placeholder: 'Ingrese su correo electrónico',
		subscribe: 'Suscribirse',
		invalidEmail: 'Por favor ingrese un correo electrónico válido',
		success: '¡Gracias por suscribirse! Revise su bandeja de entrada para ofertas exclusivas.',
		error: 'Algo salió mal. Por favor intente nuevamente.',
		privacy: 'Respetamos su privacidad. Cancele cuando quiera.',
		benefit1: 'Descuentos exclusivos',
		benefit2: 'Consejos para planificar fiestas',
		benefit3: 'Actualizaciones del menú',
	},
	myBooking: {
		title: 'Consultar Mi Reserva',
		subtitle: 'Ingrese el correo o teléfono que usó al reservar',
		emailPlaceholder: 'Ingrese su correo electrónico',
		phonePlaceholder: 'Ingrese su número de teléfono',
		search: 'Buscar Reserva',
		searching: 'Buscando...',
		results: 'Resultados',
		noResults: 'No se encontraron reservas',
		error: 'Búsqueda fallida, intente nuevamente',
		bookingId: 'ID de Reserva',
		needHelp: '¿Necesita Ayuda?',
		contactUs: 'Si tiene alguna pregunta, no dude en contactarnos',
		pendingNote: 'Le contactaremos en 2 horas para confirmar',
		confirmedNote: '¡Esperamos verle! El chef llegará 30 minutos antes',
	},
	faq: {
		title: 'Preguntas Frecuentes',
		subtitle: 'Todo lo que necesita saber',
		q1: '¿Qué áreas cubren?',
		a1: 'Actualmente servimos California, Texas y Florida. Contáctenos para verificar si cubrimos su ubicación específica.',
		q2: '¿Cuántos invitados pueden acomodar?',
		a2: 'Requerimos un mínimo de 10 invitados y podemos acomodar hasta 50. Para eventos más grandes, contáctenos para arreglos especiales.',
		q3: '¿Qué necesito proporcionar?',
		a3: '¡Solo necesita proporcionar el espacio y sus invitados! Nosotros traemos todo el equipo, ingredientes, platos, utensilios y nos encargamos de la instalación y limpieza.',
		q4: '¿Con cuánta anticipación debo reservar?',
		a4: 'Recomendamos reservar al menos 2 semanas antes para eventos entre semana y 3-4 semanas para fines de semana. ¡Las fechas populares se reservan rápido!',
		q5: '¿Acomodan restricciones dietéticas?',
		a5: '¡Sí! Ofrecemos opciones vegetarianas y podemos acomodar la mayoría de las restricciones dietéticas. Por favor infórmenos al reservar.',
		q6: '¿Cuál es su política de cancelación?',
		a6: 'Reembolso completo si cancela 7+ días antes del evento. 50% de reembolso con 3-6 días de aviso. Sin reembolso con menos de 3 días de aviso.',
	},
	contact: {
		title: 'Contáctenos',
		subtitle: 'Estamos aquí para ayudar',
		phone: 'Teléfono',
		email: 'Correo Electrónico',
		hours: 'Horario de Atención',
		address: 'Áreas de Servicio',
	},
	footer: {
		description: 'Llevando la auténtica experiencia hibachi a su hogar',
		quickLinks: 'Enlaces Rápidos',
		contact: 'Contacto',
		followUs: 'Síguenos',
		copyright: '© 2024 Family Friends Hibachi. Todos los derechos reservados.',
		allRightsReserved: 'Todos los derechos reservados.',
		privacyPolicy: 'Política de Privacidad',
		termsOfService: 'Términos de Servicio',
	},
	menuSelection: {
		title: 'SELECCIONE SU TIPO DE PLATO',
		subtitle: 'Todas las comidas incluyen arroz, vegetales hibachi y salsas especiales',
		regular: {
			title: 'REGULAR',
			proteins: '2 proteínas por persona',
			service: 'Show incluido, servicio de 90 min',
		},
		premium: {
			title: 'PREMIUM',
			proteins: '2 proteínas premium: Filete Mignon, Langosta, Vieiras',
			service: 'Show incluido, servicio de 120 min',
		},
		catering: {
			title: 'EVENTO GRANDE',
			note: '50+ invitados estilo buffet',
			proteins: '2 proteínas por persona',
			service: 'Shows incluidos, servicio de 3-4 horas',
		},
		intimate: {
			title: 'FIESTA ÍNTIMA',
			note: '5-7 invitados',
			includes: 'Ensaladas, gyoza, edamame, fideos + proteínas mixtas',
			substitution: 'Proteínas del mismo precio pueden sustituirse',
		},
	},
	form: {
		name: 'Nombre Completo',
		namePlaceholder: 'Ingrese su nombre completo',
		email: 'Correo Electrónico',
		emailPlaceholder: 'su@correo.com',
		phone: 'Número de Teléfono',
		phonePlaceholder: '(123) 456-7890',
		date: 'Fecha del Evento',
		time: 'Hora Preferida',
		guests: 'Número de Invitados',
		guestsHint: 'Mínimo 10 invitados',
		region: 'Seleccione Región',
		eventType: 'Tipo de Evento',
		message: 'Mensaje Adicional',
		messagePlaceholder: 'Cuéntenos sobre su evento...',
		submit: 'Enviar',
		submitting: 'Enviando...',
		submitReservation: 'Enviar Reservación',
		success: '¡Reservación Enviada!',
		successMessage: 'Nuestro equipo se comunicará dentro de 2 horas para confirmar los detalles.',
		weWillContact: 'Le contactaremos pronto para confirmar los detalles.',
		error: 'Algo salió mal. Por favor intente de nuevo o llámenos directamente.',
		required: 'Requerido',
		selectOption: 'Por favor seleccione',
		selectDate: 'Seleccionar fecha',
		people: 'personas',
		noPaymentRequired: '* No se requiere pago ahora. Le contactaremos para confirmar.',
		invalidEmail: 'Por favor ingrese un correo electrónico válido',
		invalidPhone: 'Por favor ingrese un número de teléfono válido',
		eventTypes: {
			birthday: 'Fiesta de Cumpleaños',
			anniversary: 'Aniversario',
			graduation: 'Graduación',
			corporate: 'Evento Corporativo',
			holiday: 'Fiesta de Día Festivo',
			other: 'Otro',
		},
		referralSource: '¿Cómo nos conoció?',
		referral: {
			google: 'Búsqueda de Google',
			friend: 'Referido por amigo',
			event: 'Visto en un evento',
			other: 'Otro',
		},
		couponCode: 'Código de Cupón',
		couponPlaceholder: 'Ingrese código de cupón (opcional)',
		applyCoupon: 'Aplicar',
	},
	estimate: {
		title: 'Obtenga Su Cotización Gratis',
		subtitle: 'Cuéntenos sobre su evento y le proporcionaremos una cotización personalizada',
		benefits: {
			title: '¿Por Qué Elegirnos?',
			professional: 'Chefs profesionales capacitados',
			fresh: 'Ingredientes frescos de alta calidad',
			entertainment: 'Entretenimiento de cocina en vivo',
			cleanup: 'Instalación y limpieza completa',
			custom: 'Opciones de menú personalizables',
		},
	},
	bookNow: {
		title: 'Reserve Su Fiesta Hibachi',
		subtitle: 'Complete el formulario para reservar su fecha',
		selectRegion: 'Primero, seleccione su región',
		formTitle: 'Detalles del Evento',
		pricing: 'Precios desde $45/persona',
		note: 'Confirmaremos disponibilidad dentro de 2 horas',
	},
	notFound: {
		title: 'Página No Encontrada',
		description: 'La página que busca no existe.',
		backHome: 'Volver al Inicio',
	},
	common: {
		learnMore: 'Más Información',
		viewAll: 'Ver Todo',
		loading: 'Cargando...',
		close: 'Cerrar',
		backToHome: 'Volver al Inicio',
		total: 'Total',
		toBeConfirmed: 'Por confirmar',
		specialOffer: 'Oferta Especial',
		goTo: 'Ir a',
		previous: 'Anterior',
		next: 'Siguiente',
	},
	topBar: {
		textUs: 'Envíenos Texto',
		email: 'Correo',
	},
	photoShare: {
		title: 'Comparta Sus Fotos',
		subtitle: '¡Comparta su experiencia Hibachi y obtenga $25 de descuento en su próximo evento!',
		option1Title: 'Publicar en Instagram',
		option1Desc: 'Etiquétenos y use #FamilyFriendsHibachi',
		option2Title: 'Subir Directamente',
		option2Desc: 'Comparta sus fotos con nosotros',
		dropzone: 'Arrastre y suelte fotos aquí o haga clic para buscar',
		maxFiles: 'Hasta 5 fotos',
		instagramPlaceholder: 'Su usuario de Instagram (opcional)',
		submit: 'Enviar Fotos',
		submitting: 'Subiendo...',
		successTitle: '¡Fotos Enviadas!',
		successDesc: '¡Gracias por compartir! Su crédito de $25 se aplicará en su próxima reserva.',
		terms: '* Crédito aplicado después de la revisión. Las fotos pueden aparecer en nuestras redes sociales.',
	},
	offer: {
		noTravel: 'Sin Cargo por Viaje',
		within50: 'Dentro de 50 Millas',
		noHidden: 'Sin cargos ocultos',
		exclusive: 'Descuentos exclusivos',
		freeSetup: 'Mesas y sillas gratis',
		sunFri: '¡Especial de Domingo a Viernes!',
	},
	coupon: {
		minGuests: 'Mínimo {{count}} invitados requeridos',
		applied: '¡Cupón aplicado! Descuento: {{discount}}',
		invalid: 'Código de cupón inválido',
		checkFailed: 'Verificación fallida',
		under15: 'menos de 15 personas',
		range15to25: '15-25 personas',
		range25to35: '25-35 personas',
		over35: '35+ personas',
	},
	privacy: {
		title: 'Política de Privacidad',
		lastUpdated: 'Última actualización: Enero 2026',
		section1: {
			title: '1. Información que Recopilamos',
			intro: 'Cuando utiliza los servicios de Family Friends Hibachi, podemos recopilar:',
			contact: 'Información de Contacto',
			contactDesc: 'Nombre, correo electrónico, número de teléfono',
			booking: 'Detalles de Reserva',
			bookingDesc: 'Fecha del evento, hora, ubicación, número de invitados',
			payment: 'Información de Pago',
			paymentDesc: 'Procesada de forma segura a través de proveedores externos',
			usage: 'Datos de Uso',
			usageDesc: 'Cómo interactúa con nuestro sitio web',
		},
		section2: {
			title: '2. Cómo Usamos Su Información',
			item1: 'Procesar y confirmar sus reservas',
			item2: 'Enviar confirmaciones y recordatorios',
			item3: 'Responder a sus consultas',
			item4: 'Mejorar nuestros servicios',
			item5: 'Enviar ofertas promocionales (con su consentimiento)',
		},
		section3: {
			title: '3. Compartir Información',
			intro: 'No vendemos su información personal. Podemos compartir información con:',
			item1: 'Proveedores de servicios que asisten en nuestras operaciones',
			item2: 'Autoridades legales cuando lo requiera la ley',
		},
		section4: {
			title: '4. Seguridad de Datos',
			desc: 'Implementamos medidas de seguridad apropiadas para proteger su información personal. Sin embargo, ninguna transmisión por internet es 100% segura.',
		},
		section5: {
			title: '5. Sus Derechos',
			intro: 'Usted tiene derecho a:',
			item1: 'Acceder a sus datos personales',
			item2: 'Solicitar corrección de datos inexactos',
			item3: 'Solicitar eliminación de sus datos',
			item4: 'Optar por no recibir comunicaciones de marketing',
		},
		section6: {
			title: '6. Cookies',
			desc: 'Usamos cookies para mejorar su experiencia de navegación y analizar el tráfico del sitio. Puede controlar las cookies a través de la configuración de su navegador.',
		},
		section7: {
			title: '7. Contáctenos',
			intro: 'Para preguntas relacionadas con privacidad:',
		},
	},
	terms: {
		title: 'Términos de Servicio',
		lastUpdated: 'Última actualización: Enero 2026',
		section1: {
			title: '1. Servicios',
			desc: 'Family Friends Hibachi proporciona servicios de catering hibachi móvil. Llevamos chefs profesionales y equipos a su ubicación para preparar auténticas comidas hibachi.',
		},
		section2: {
			title: '2. Reservas',
			minimum: 'Mínimo de Invitados',
			minimumDesc: 'Se requieren mínimo 10 invitados',
			confirmation: 'Confirmación',
			confirmationDesc: 'Las reservas se confirman después de que nuestro equipo le contacte',
			deposit: 'Depósito',
			depositDesc: 'Puede requerirse un depósito para asegurar su fecha',
			finalCount: 'Conteo Final',
			finalCountDesc: 'El número de invitados debe confirmarse 48 horas antes del evento',
		},
		section3: {
			title: '3. Política de Cancelación',
			sevenDays: '7+ días de anticipación',
			sevenDaysDesc: 'Reembolso completo del depósito',
			threeSixDays: '3-6 días de anticipación',
			threeSixDaysDesc: '50% del depósito reembolsado',
			lessThanThree: 'Menos de 3 días',
			lessThanThreeDesc: 'El depósito no es reembolsable',
			weather: 'Clima',
			weatherDesc: 'Reprogramaremos sin cargo por clima severo',
		},
		section4: {
			title: '4. Responsabilidades del Cliente',
			intro: 'Los clientes deben proporcionar:',
			item1: 'Espacio exterior adecuado para cocinar (mínimo 10x10 pies)',
			item2: 'Acceso a electricidad (enchufe estándar dentro de 50 pies)',
			item3: 'Mesas y asientos para invitados',
			item4: 'Protección contra el clima si es necesario (carpa, gazebo, etc.)',
		},
		section5: {
			title: '5. Seguridad Alimentaria y Alergias',
			desc: 'Por favor infórmenos sobre cualquier alergia alimentaria o restricción dietética al momento de reservar. Aunque tomamos precauciones, no podemos garantizar un ambiente completamente libre de alérgenos debido a la naturaleza de la cocina hibachi.',
		},
		section6: {
			title: '6. Responsabilidad',
			desc: 'Family Friends Hibachi cuenta con seguro de responsabilidad. Sin embargo, los clientes son responsables de sus invitados y propiedad. No somos responsables de accidentes causados por el comportamiento de los invitados o condiciones preexistentes de la propiedad.',
		},
		section7: {
			title: '7. Área de Servicio',
			intro: 'Actualmente servimos:',
			california: 'California (Los Ángeles, San Diego, San Francisco y áreas circundantes)',
			texas: 'Texas (Houston, Dallas, Austin, San Antonio y áreas circundantes)',
			florida: 'Florida (Miami, Fort Lauderdale y áreas circundantes)',
			travelFee: 'Pueden aplicarse tarifas de viaje para ubicaciones fuera de nuestra área de servicio estándar.',
		},
		section8: {
			title: '8. Cambios en los Términos',
			desc: 'Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado de nuestros servicios constituye aceptación de los términos actualizados.',
		},
		section9: {
			title: '9. Contacto',
			intro: 'Preguntas sobre estos términos:',
		},
	},
	status: {
		pending: 'Pendiente',
		confirmed: 'Confirmado',
		completed: 'Completado',
		cancelled: 'Cancelado',
	},
	timeSlot: {
		afternoon: 'Tarde',
		evening: 'Noche temprana',
		night: 'Noche',
	},
	admin: {
		login: {
			title: 'Inicio de Sesión Admin',
			subtitle: 'Ingrese la contraseña para acceder al panel',
			password: 'Contraseña',
			loginButton: 'Iniciar Sesión',
			loggingIn: 'Iniciando sesión...',
			invalidPassword: 'Contraseña inválida',
			loginFailed: 'Error de inicio de sesión. Intente de nuevo.',
			contactHelp: 'Contacte para acceso',
		},
		dashboard: {
			title: 'Panel de Administración',
			logout: 'Cerrar Sesión',
		},
		stats: {
			totalBookings: 'Total de Reservas',
			pending: 'Pendientes',
			confirmed: 'Confirmadas',
			completed: 'Completadas',
			cancelled: 'Canceladas',
			totalGuests: 'Total de Invitados',
		},
		tabs: {
			all: 'Todas',
			pending: 'Pendientes',
			confirmed: 'Confirmadas',
			completed: 'Completadas',
			cancelled: 'Canceladas',
		},
		booking: {
			noBookings: 'No se encontraron reservas',
			noBookingsHint: 'Las reservas aparecerán aquí cuando los clientes envíen formularios',
			booking: 'Reserva',
			estimate: 'Cotización',
			guests: 'invitados',
			contactInfo: 'Información de Contacto',
			eventDetails: 'Detalles del Evento',
			date: 'Fecha',
			time: 'Hora',
			region: 'Región',
			notSpecified: 'No especificado',
			additionalNotes: 'Notas Adicionales',
			updateStatus: 'Actualizar Estado',
			emailCustomer: 'Enviar Email',
			callCustomer: 'Llamar Cliente',
		},
	},
};

export default es;
